import YellowRectangle from "../../public/assets/yellow-rectangle.svg";
import styles from "../../styles/SectionHeader.module.scss";

export default function SectionHeader({
  children,
  className,
}: {
  children: string;
  className?: string;
}) {
  return (
    <div className={`${styles.main} ${className}`}>
      <YellowRectangle className={styles.decorator}></YellowRectangle>
      <p>{children}</p>
      <YellowRectangle className={styles.decorator}></YellowRectangle>
    </div>
  );
}
